<div class="row">
    <!-- Progress bar do Angular Material enquanto o editor não carrega -->
    <mat-progress-bar
    *ngIf="!editorLoaded"
    mode="indeterminate"
    color="primary"
    class="my-4"
  ></mat-progress-bar>
    <editor
    *ngIf="editorLoaded"
    [disabled]="BloquearEdicao"
    (ngModelChange)="onEditorContentChange($event)"
    [init]="editorConfig" [(ngModel)]="editorContent"
  ></editor>

   </div>
